module.exports = __webpack_public_path__ + "img/logo_black.55c007b1.svg";